export type ColorTheme = { bg: string; fg: string; color1: string; color2: string }

export const COLOR_KEYS: { key: keyof ColorTheme; label: string; cssVar: string }[] = [
  { key: 'bg', label: 'bg', cssVar: '--color-bg' },
  { key: 'fg', label: 'fg', cssVar: '--color-fg' },
  { key: 'color1', label: '1', cssVar: '--color-1' },
  { key: 'color2', label: '2', cssVar: '--color-2' },
]

export function defaultColorTheme(): ColorTheme {
  const get = (v: string, fb: string) =>
    getComputedStyle(document.documentElement).getPropertyValue(v).trim() || fb
  return {
    bg: get('--color-bg', '#0d0d0d'),
    fg: get('--color-fg', '#e8e8e8'),
    color1: get('--color-1', '#c0392b'),
    color2: get('--color-2', '#2980b9'),
  }
}
